
import React, { useEffect } from "react";
import Footer from "../components/Shared/Footer";

import BlendsSection from "../components/Shared/BlendsSection";

import Testimonials from "../components/Shared/Testimonials";
import ScrollingText from "../components/Shared/ScrollingText";

import { Link } from "react-router-dom";
import BannerCorousel from "../components/Shared/BannerCarousel";




const Home = () => {


  return (
    <div>
      <div>
        <BannerCorousel />
        <br></br>
        <div className="container-fluid-lg z-2 number_section justify-content-center align-items-center d-flex">
          <div className="row box_shadow_banner  width_row_home_section justify-content-center align-items-center background_bluebanner">
            <div className="col-xl-3 padding_box_blue">
              <div className="text-white text-center font-lg fw-bold">+50</div>
              <div className="text-white text-center font-sm">
                Yrs of <br/>experience
              </div>
            </div>
            <div className="col-xl-3 padding_box_blue">
              <div className="text-white text-center font-lg fw-bold">+30</div>
              <div className="text-white text-center font-sm">
                Innovative<br/> products
              </div>
            </div>
            <div className="col-xl-3 padding_box_blue">
              <div className="text-white text-center font-lg fw-bold">
                +300
              </div>
              <div className="text-white text-center font-sm"> New product <br /> registrations  </div>
            </div>
            <div className="col-xl-3 padding_box_blue">
              <div className="text-white text-center font-lg fw-bold">+10</div>
              <div className="text-white text-center font-sm">
              Innovative <br/>Nutrition Solutions
              </div>
            </div>
          </div>
        </div>

        <section className="fresh-vegetable-section section-lg-space">
          <div className="container-fluid-lg">
            <div className="row gx-xl-5 gy-xl-0 g-3 ratio_148_1">
              <div className="col-xl-6 col-12">
                <div className="row g-sm-4 g-2">
                  <div className="col-6">
                    <div className="fresh-image-2">
                      <div
                        className="bg-size blur-up lazyloaded"
                        style={{
                          backgroundImage:
                            "url(../assets/images/ReducarbHim&Her/reduhimone.jpg)",
                          backgroundSize: "cover",
                          backgroundPosition: "center center",
                          backgroundRepeat: "no-repeat",
                          display: "block",
                        }}
                      ></div>
                    </div>
                  </div>

                  <div className="col-6">
                    <div className="fresh-image">
                      <div
                        className="bg-size blur-up lazyloaded"
                        style={{
                          backgroundImage:
                            "url(../assets/images/ReducarbHim&Her/reduhimtwo.jpg)",
                          backgroundSize: "cover",
                          backgroundPosition: "center center",
                          backgroundRepeat: "no-repeat",
                          display: "block",
                        }}
                      ></div>
                    </div>
                  </div>
                </div>
              </div>

              <div className="col-xl-6 col-12">
                <div className="fresh-contain p-center-left">
                  <div>
                    <div className=" mb-4">
                      <h2 className="font_Home_section">
                        <span style={{color: 'var(--theme-color1)'}}>Redu</span><span style={{color: 'var(--theme-color)'}}>carb</span> for Him and Her
                      </h2>
                    </div>

                    <div className="delivery-list">
                      <p className="font-xsm ">
                        We differ in our needs and body metabolism. <span style={{color: 'var(--theme-color1)'}}>Redu</span><span style={{color: 'var(--theme-color)'}}>carb</span> 'Him' and 'Her' are designed based on such gender specific differences catering to their individual needs.
                      </p>


                    </div>
                    <Link to="/reducarb-variants/:blendName">
                      <button className=" btn_get_started btns btn-animation-blue  mt-2 home-button"
                      >
                        Know more

                      </button>
                    </Link>

                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>

        <section className="client-section  section-lg-space padding_section_redubenifits  ">
          <div className="container-fluid-lg ">
            <div className="">
              <div className="text-center mb-5">

                <h2 className="center font_Home_section mb-2 ">
                  <span className="fw-bold">Redu</span>carb Benefits
                </h2>
                <div className="font-xsm">Reducarb helps to solve your health issues as follows</div>
              </div>
            </div>
          </div>
        </section>

        <div className="container-fluid-lg z-2 reducarb_card_section">
          <div className="row">
            <div className="d-flex flex-wrap ">
              <div className="col-xl-3 mb-3 px-2">
                <div className="card profile-card mx-auto h-100">
                  <div className="custom-image-container">
                    <img
                      src="../assets/images/ReducarbBenifits/redubenicardone.jpg"
                      className="custom-image blur-up-img lazyloaded-img card_imd_fit"
                      alt=""
                    />
                  </div>
                  <div className="card-body d-flex flex-column">
                    <h2 className="mb-2 font-md">Pre-diabetes</h2>
                    <hr />
                    <p className="text-muted">
                      Pre-diabetes means your blood glucose levels are higher than normal but not high enough to be clinically diagnosed as diabetes.
                    </p>
                    {/* <Link className="d-flex justify-content-start gap-2 align-items-center mt-auto" to="/pre-diabetes">
                      <div className="button_text">Know More</div>
                      <i className="fa-solid fa-chevron-right margin_top_arrow"></i>
                    </Link> */}
                    <Link to="/pre-diabetes">
                      <button className=" btn_get_started btns btn-animation-blue  mt-2 home-button"
                      >
                        Know more

                      </button>
                    </Link>
                  </div>
                </div>
              </div>

              <div className="col-xl-3 mb-3 px-2">
                <div className="card profile-card mx-auto h-100">
                  <div className="custom-image-container">
                    <img
                      src="../assets/images/ReducarbBenifits/redubenicardtwo.jpg"
                      className="custom-image blur-up-img lazyloaded-img card_imd_fit"
                      alt=""
                    />
                  </div>
                  <div className="card-body d-flex flex-column">
                    <h2 className="mb-2 font-md">Abdominal obesity</h2>
                    <hr />
                    <p className="text-muted">
                      As per the WHO, obesity is defined as abnormal or excessive fat accumulation in our body, which is viewed as a significant risk to health.
                    </p>
                    {/* <Link to="/abdominal-obesity" className="d-flex justify-content-start gap-2 align-items-center mt-auto">
                      <div className="button_text">Know More</div>
                      <i className="fa-solid fa-chevron-right margin_top_arrow"></i>
                    </Link> */}
                    <Link to="/abdominal-obesity">
                      <button className=" btn_get_started btns btn-animation-blue  mt-2 home-button"
                      >
                        Know more

                      </button>
                    </Link>
                  </div>
                </div>
              </div>

              <div className="col-xl-3 mb-3 px-2">
                <div className="card profile-card mx-auto h-100">
                  <div className="custom-image-container">
                    <img
                      src="../assets/images/ReducarbBenifits/redubenicardthree.jpg"
                      className="custom-image blur-up-img lazyloaded-img card_imd_fit"
                      alt=""
                    />
                  </div>
                  <div className="card-body d-flex flex-column">
                    <h2 className="mb-2 font-md">Metabolic syndrome</h2>
                    <hr />
                    <p className="text-muted">
                      Metabolic syndrome is a group of conditions that together raise your risk of coronary heart disease, diabetes, stroke, and other problems.
                    </p>
                    {/* <Link to="/risk-heart-disease" className="d-flex justify-content-start gap-2 align-items-center mt-auto">
                      <div className="button_text">Know More</div>
                      <i className="fa-solid fa-chevron-right margin_top_arrow"></i>
                    </Link> */}
                    <Link to="/risk-heart-disease">
                      <button className=" btn_get_started btns btn-animation-blue  mt-2 home-button"
                      >
                        Know more

                      </button>
                    </Link>
                  </div>
                </div>
              </div>

              <div className="col-xl-3 mb-3 px-2">
                <div className="card profile-card mx-auto h-100">
                  <div className="custom-image-container">
                    <img
                      src="../assets/images/ReducarbBenifits/redubenicardfour.jpg"
                      className="custom-image blur-up-img lazyloaded-img card_imd_fit"
                      alt=""
                    />
                  </div>
                  <div className="card-body d-flex flex-column">
                    <h2 className="mb-2 font-md">Unhealthy habits</h2>
                    <hr />
                    <p className="text-muted">
                      Eating too much or too little or eating non-nutritious food or irregular timings of taking meals are called unhealthy dietary habits.
                    </p>
                    {/* <Link to="/unhealthy" className="d-flex justify-content-start gap-2 align-items-center mt-auto">
                      <div className="button_text">Know More</div>
                      <i className="fa-solid fa-chevron-right margin_top_arrow"></i>
                    </Link> */}
                    <Link to="/unhealthy">
                      <button className=" btn_get_started btns btn-animation-blue  mt-2 home-button"
                      >
                        Know more

                      </button>
                    </Link>
                  </div>
                </div>
              </div>
            </div>
          </div>


        </div>

        {/* <section className="fresh-vegetable-section section-lg-space blue-color-section">
          <div className="container-fluid-lg">
            <div className="">
              <div className="text-center mb-5">

                <h2 className="center font_Home_section mb-2 ">
                  Why <span style={{color: 'var(--theme-color1)'}}>Redu</span><span style={{color: 'var(--theme-color)'}}>carb</span>?
                </h2>
                <div className="font-xsm">Low carbohydrate, High fiber with plant proteins support...</div>
              </div>
            </div>
            <div className="row mb-3">
              <div className="col-xl-4 d-flex justify-content-center mb-3  ">
                <div className="clint-contain width-whyreducarb card-whyreducarb gap-3 d-flex justify-content-center align-items-center ">
                  <div className="client-icon">
                    <img
                      src="../assets/images/icons_homepage/weightcontrol.png"
                      className="blur-up lazyload mb-2"
                      alt=""
                    />
                  </div>

                  <div className="font-md fw-semibold">Weight control
                  </div>

                </div>
              </div>
              <div className="col-xl-4 d-flex justify-content-center mb-3 ">
                <div className="clint-contain width-whyreducarb card-whyreducarb  gap-3 d-flex justify-content-center align-items-center ">
                  <div className="client-icon">
                    <img
                      src="../assets/images/icons_homepage/heart_health.png"
                      className="blur-up lazyload mb-2"
                      alt=""
                    />
                  </div>

                  <div className="font-md fw-semibold">Heart health
                  </div>

                </div>
              </div>
              <div className="col-xl-4 d-flex justify-content-center mb-3 ">
                <div className="clint-contain width-whyreducarb card-whyreducarb  gap-3 d-flex justify-content-center align-items-center ">
                  <div className="client-icon">
                    <img
                      src="../assets/images/icons_homepage/Activelifestyle.png"
                      className="blur-up lazyload mb-2"
                      alt=""
                    />
                  </div>

                  <div className="font-md fw-semibold">Active lifestyle
                  </div>

                </div>
              </div>



            </div>
            <div className="row">
              <div className="col-xl-4 d-flex justify-content-center mb-3 ">
                <div className="clint-contain width-whyreducarb card-whyreducarb  gap-3 d-flex justify-content-center align-items-center ">
                  <div className="client-icon">
                    <img
                      src="../assets/images/icons_homepage/Elegantlooks.png"
                      className="blur-up lazyload mb-2"
                      alt=""
                    />
                  </div>

                  <div className="font-md fw-semibold">Elegant looks
                  </div>

                </div>
              </div>
              <div className="col-xl-4 d-flex justify-content-center mb-3 ">
                <div className="clint-contain width-whyreducarb card-whyreducarb  gap-3 d-flex justify-content-center align-items-center ">
                  <div className="client-icon">
                    <img
                      src="../assets/images/icons_homepage/pre-diabetes.png"
                      className="blur-up lazyload mb-2"
                      alt=""
                    />
                  </div>

                  <div className="font-md fw-semibold">Pre-diabetes
                  </div>

                </div>
              </div>
              <div className="col-xl-4 d-flex justify-content-center mb-3 ">
                <div className="clint-contain width-whyreducarb card-whyreducarb  gap-3 d-flex justify-content-center align-items-center ">
                  <div className="client-icon">
                    <img
                      src="../assets/images/icons_homepage/Genderspecificnutrition.png "
                      className="blur-up lazyload mb-2"
                      alt=""
                    />
                  </div>

                  <div className="font-md fw-semibold">Gender specific nutrition
                  </div>

                </div>
              </div>



            </div>
          </div>
        </section> */}


<section className="fresh-vegetable-section section-lg-space blue-color-section">
  <div className="container-fluid-lg">
    <div className="text-center mb-5">
      <h2 className="center font_Home_section mb-2 ">
        Why <span style={{ color: 'var(--theme-color1)' }}>Redu</span>
        <span style={{ color: 'var(--theme-color)' }}>carb</span>?
      </h2>
      <div className="font-xsm">Low carbohydrate, High fiber with plant proteins support...</div>
    </div>

    <div className="row mb-3">
      {[
        { src: "weightcontrol.png", text: "Weight control" },
        { src: "heart_health.png", text: "Heart health" },
        { src: "Activelifestyle.png", text: "Active lifestyle" },
        { src: "Elegantlooks.png", text: "Elegant looks" },
        { src: "pre-diabetes.png", text: "Pre-diabetes" },
        { src: "Genderspecificnutrition.png", text: "Gender specific nutrition" },
      ].map((item, index) => (
        <div key={index} className="col-xl-4 d-flex justify-content-center mb-3">
          <div className="clint-contain width-whyreducarb card-whyreducarb d-flex flex-column align-items-center text-center gap-3">
            <div className="client-icon">
              <img
                src={`../assets/images/icons_homepage/${item.src}`}
                className="blur-up lazyload mb-2"
                alt=""
              />
            </div>
            <div className="font-md fw-semibold">{item.text}</div>
          </div>
        </div>
      ))}
    </div>
  </div>
</section>

{/* <section className="fresh-vegetable-section section-lg-space blue-color-section">
  <div className="container">
    <div className="text-center mb-4">
      <h2 className="center font_Home_section mb-2">
        Why <span style={{ color: 'var(--theme-color1)' }}>Redu</span>
        <span style={{ color: 'var(--theme-color)' }}>carb</span>?
      </h2>
      <div className="font-xsm">
        Low carbohydrate, High fiber with plant proteins support...
      </div>
    </div>

    <div className="row g-4">
      {[
        { img: "weightcontrol.png", text: "Weight control" },
        { img: "heart_health.png", text: "Heart health" },
        { img: "Activelifestyle.png", text: "Active lifestyle" },
        { img: "Elegantlooks.png", text: "Elegant looks" },
        { img: "pre-diabetes.png", text: "Pre-diabetes" },
        { img: "Genderspecificnutrition.png", text: "Gender specific nutrition" },
      ].map((item, index) => (
        <div key={index} className="col-12 col-md-4 d-flex justify-content-center">
          <div className="clint-contain card-whyreducarb d-flex flex-column align-items-center text-center p-4 shadow rounded bg-white w-100">
            <img
              src={`../assets/images/icons_homepage/${item.img}`}
              className="img-fluid mb-3"
              alt={item.text}
              style={{ maxWidth: "80px", height: "auto" }} 
            />
            <div className="font-md fw-semibold">{item.text}</div>
          </div>
        </div>
      ))}
    </div>
  </div>
</section> */}


        <BlendsSection />

        <div className="background_banner_section_blue py-4">
          <div className="container-fluid-lg">
            <div className="d-flex align-items-center justify-content-center">

              <ScrollingText />

            </div>
          </div>
        </div>

        <section className="review-section  section-lg-space">
          <Testimonials />
        </section>

        <div>
          <Footer />
        </div>
      </div>
    </div>
  );
};

export default Home;
